// export enum Role {
//   OWNER = 'owner',
//   ADMIN = 'admin',
//   ANALYST = 'analyst',
//   DEALER = 'dealer',
//   DEVELOPER = 'developer',
//   SUZETTE = 'suzette',
//   ANGIE = 'angie',
// }

import { AwsCognitoUser } from './user.model';

export enum Permission {
  CREATE_DEALER = 'create-dealer',
  UPDATE_DEALER = 'update-dealer',
  ARCHIVE_DEALER = 'archive-dealer',
  ARCHIVE_APPLICATION = 'archive-application',
  CUSTOM_DEALER_EMAIL_TEMPLATE = 'custom-dealer-email-template',
  CUSTOM_DEALER_THEME = 'custom-dealer-theme',
  SERVICE_PAY = 'service-pay',

  MANAGE_QUOTES = 'manage-quotes',
  CREATE_QUOTE = 'create-quote',
  MANAGE_FEES = 'manage-fees',
  VIEW_FEE_LOGS = 'view-fee-logs',

  MANAGE_DOCUMENTS = 'manage-documents',
  MANAGE_ADMIN_DOCS = 'manage-admin-docs',
  MANAGE_NEWS = 'manage-news',
  MANAGE_USERS = 'manage-users',
  VIEW_ANALYTIC_REPORT = 'view-analytic-report',

  MANAGE_DEALER_PROSPECTS = 'manage-dealer-prospects',
  ARCHIVE_DEALER_PROSPECT = 'archive-dealer-prospect',
  CREATE_DEALER_PROSPECT = 'create-dealer-prospect',
  MANAGE_MY_LEADS = 'manage-my-leads',

  VIEW_DEALER_API_ACCESS = 'view-dealer-api-access',
  MANAGE_DEALER_API_ACCESS = 'manage-dealer-api-access',

  DEALER_REGISTRATION_DOCS = 'dealer-registration-docs',
  VIEW_DEALER_LOGS = 'view-dealer-logs',
  VIEW_QUOTE_LOGS = 'view-quote-logs',

  MANAGE_DEALER_DOCUMENTS = 'manage-dealer-documents',

  CONTRACTING = 'contracting',
}

export const POSITION_OPTIONS = {
  analyst: 'Analyst',
  title_specialist: 'Title Specialist',
  senior_title_specialist: 'Senior Title Specialist',
  title_support: 'Title Support',
  document_processor: 'Document Processor',
  controller: 'Controller',
  dealer_development: 'Dealer Development',
  development_specialist: 'Development Specialist',
  dealer_relationship: 'Dealer Relationship',
  marketing: 'Marketing',
  coo: 'COO',
  cco: 'CCO',
  cao: 'CAO',
  cfo: 'CFO',
};

// export const PERMISSIONS: Record<Role, Permission[]> = {
//   [Role.OWNER]: [
//     Permission.CREATE_DEALER,
//     Permission.UPDATE_DEALER,
//     Permission.ARCHIVE_DEALER,
//     Permission.ARCHIVE_APPLICATION,
//     Permission.CUSTOM_DEALER_EMAIL_TEMPLATE,
//     Permission.CUSTOM_DEALER_THEME,
//     Permission.SERVICE_PAY,

//     Permission.MANAGE_QUOTES,
//     Permission.CREATE_QUOTE,
//     Permission.MANAGE_FEES,
//   ],
//   [Role.ADMIN]: [
//     Permission.CREATE_DEALER,
//     Permission.UPDATE_DEALER,
//     Permission.ARCHIVE_APPLICATION,
//     // Permission.MANAGE_QUOTES,
//     // Permission.CREATE_QUOTE,
//     // Permission.MANAGE_FEES,
//   ],
//   [Role.ANALYST]: [
//     // Permission.MANAGE_QUOTES,
//     // Permission.CREATE_QUOTE, //
//   ],
//   [Role.DEALER]: [
//     Permission.CREATE_DEALER, //
//     Permission.UPDATE_DEALER,
//     Permission.ARCHIVE_DEALER,
//   ],
//   [Role.DEVELOPER]: [
//     Permission.CREATE_DEALER,
//     Permission.UPDATE_DEALER,
//     Permission.ARCHIVE_DEALER,
//     Permission.ARCHIVE_APPLICATION,
//     Permission.CUSTOM_DEALER_EMAIL_TEMPLATE,
//     Permission.CUSTOM_DEALER_THEME,
//     Permission.SERVICE_PAY,

//     Permission.MANAGE_QUOTES,
//     Permission.CREATE_QUOTE,
//     Permission.MANAGE_FEES,
//   ],
//   // TEMP ROLE
//   [Role.SUZETTE]: [
//     Permission.CREATE_DEALER,
//     Permission.UPDATE_DEALER,
//     Permission.ARCHIVE_DEALER,
//     Permission.ARCHIVE_APPLICATION,
//     Permission.SERVICE_PAY,

//     Permission.MANAGE_QUOTES,
//     Permission.CREATE_QUOTE,
//     Permission.MANAGE_FEES,
//   ],
//   [Role.ANGIE]: [
//     Permission.MANAGE_QUOTES,
//     Permission.CREATE_QUOTE,
//     Permission.MANAGE_FEES,
//     Permission.SERVICE_PAY, //
//   ],
// };

export const hasPermission = (user: AwsCognitoUser, permission: Permission) => {
  if (!user || !user['custom:permissions']) {
    return false;
  }
  
  const permissions = user['custom:permissions'];
  
  // Handle array case
  if (Array.isArray(permissions)) {
    return permissions.includes(permission);
  }
  
  // Handle string case - split by comma and check for exact match
  // Type assertion needed because Cognito can return string or array
  const permissionsValue = permissions as unknown;
  if (typeof permissionsValue === 'string') {
    return permissionsValue.split(',').some((p: string) => p.trim() === permission);
  }
  
  return false;
};
